import type { ModuleDefinition } from '../../app/moduleRegistry';
import PaymentReturnPage from './PaymentReturnPage';

/**
 * Cross-cutting booking routes that don't belong to a single product module. Currently
 * just the 3D Secure return landing (`/payment/return`) — the bank redirects the
 * browser here after card authentication. No menu item; it's only ever reached by
 * redirect.
 */
export const bookingModule: ModuleDefinition = {
  routes: [{ path: 'payment/return', element: <PaymentReturnPage /> }],
  menuItems: [],
};
